import type { TAmPm, THours, TMins } from "../types/time_picker";

export const HOURS = [
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12'
] as const;

const MINUTES_AND_SECONDS = [
  '00',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '31',
  '32',
  '33',
  '34',
  '35',
  '36',
  '37',
  '38',
  '39',
  '40',
  '41',
  '42',
  '43',
  '44',
  '45',
  '46',
  '47',
  '48',
  '49',
  '50',
  '51',
  '52',
  '53',
  '54',
  '55',
  '56',
  '57',
  '58',
  '59'
] as const;

export const MINUTES = MINUTES_AND_SECONDS;
export const SECONDS = MINUTES_AND_SECONDS;
export const AM_PM = ['AM', 'PM'] as const;

export const getCurrentTime12hr = () => {
  const now = new Date();

  let hour = now.getHours();
  const minute = now.getMinutes();
  const ampm = hour >= 12 ? 'PM' : 'AM';

  // Convert to 12-hour format
  hour = hour % 12;
  // If hours was 0 (midnight), make it 12
  hour = hour === 0 ? 12 : hour;

  // Add leading zero to minutes if needed
  const hourStr = hour.toString().padStart(2, '0');
  const minuteStr = minute.toString().padStart(2, '0');

  return {
    hour: hourStr as THours,
    minute: minuteStr as TMins,
    ampm: ampm as TAmPm,
    formattedTime: `${hourStr}:${minuteStr} ${ampm}`
  };
};

export const convert24to12hr = (time24: number | string) => {
  // Create a new Date object. We append a dummy date because 
  // the Date object requires a full date and time for correct operation.
  if (!time24) return '';
  const dateObj = new Date(`2000-01-01T${time24}`);

  // Use toLocaleTimeString to format the time in 12-hour format.
  // 'en-US' locale is specified to ensure AM/PM is used.
  const time12hr = dateObj.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  });

  return time12hr;
};